// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3CfkT","row":"ProcedureTreatmentSummary_row__1MDUA"};